export const excludePath = ['/assets/', '/assets/', '/static/', '/media/']

export const excludeContent = [
  'Network Error',
  'Token has expired and can no longer be refreshed',
  'Unauthenticated',
  'This action is unauthorized',
]

export const excludeStatusCodes = [401, 422]
